var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWthoutNotificationsBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 440.35 440.35",
    xmlSpace: "preserve",
    fill: "#c9ced6",
    stroke: "#c9ced6",
    strokeWidth: 0.00440349,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.880698
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9ced6"
    },
    d: "M409.916,365.883c-21.63,0-47.398-62.476-51.291-155.134v-72.564 C358.625,61.989,296.636,0,220.439,0S82.253,61.989,82.253,138.186v47.861c0,102.932-27.361,179.845-51.82,179.845 c-4.487,0-8.129,3.633-8.129,8.129c0,4.495,3.642,8.129,8.129,8.129h379.483c4.495,0,8.129-3.633,8.129-8.129 C418.044,369.525,414.411,365.883,409.916,365.883z M58.932,365.883c25.881-32.335,39.586-107.809,39.586-179.845v-47.861 c0-67.231,54.697-121.929,121.929-121.929s121.929,54.697,121.929,121.929l0.008,72.905 c2.552,60.997,15.615,125.448,39.058,154.792H58.932V365.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9ced6"
    },
    d: "M262.171,391.684c-4.495,0-8.129,3.633-8.129,8.129c0,13.16-15.509,24.28-33.872,24.28 s-33.872-11.12-33.872-24.28c0-4.495-3.642-8.129-8.129-8.129c-4.487,0-8.129,3.633-8.129,8.129 c0,22.354,22.492,40.537,50.129,40.537s50.129-18.184,50.129-40.537C270.299,395.317,266.666,391.684,262.171,391.684z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWthoutNotificationsBell);
export default __webpack_public_path__ + "static/media/wthout-notifications-bell.cb3ff663b425bfa53a382c57e34152a4.svg";
export { ForwardRef as ReactComponent };